import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';
import { useRef, useState } from 'react';

interface IButton {
  title?: string;
  label: string;
  menu: any;
  onChange?(value: string): void;
}

const DropdownButton = (props: IButton) => {
  const [autoComplete, setAutoComplete] = useState(false);
  const refSelect = useRef<HTMLSelectElement>();

  const onSelectItem = (value: string) => {
    props.onChange?.(value);
    setAutoComplete(false);
    setTimeout(() => {
      refSelect.current?.blur();
    }, 100);
  };
  return (
    <div className="dropdown-wrapper">
      <p>{props.title}</p>
      <Dropdown
        overlay={props.menu}
        trigger={['click']}
        className="sellDropdown"
      >
        <a>
          <Space onClick={(e: any) => onSelectItem(e.target.value)}>
            {props.label}
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </div>
  );
};

export default DropdownButton;
